import React, { useState } from "react";
import moment from "moment";

const AircraftFuelUpliftValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({

    error: null,
    errorMessage: null,
    field: null,
  }); 

  let field = null;
  let error = false;
  let errorMessage = "";

  if (!record) return; 

  // if (!record.upliftedFuelQty) {
  //   error = true;
  //   errorMessage = "The 'Uplifted Fuel' weight may not be less than zero";
  //   field = "upliftedFuelQty";
  // }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {        
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );

}

export default AircraftFuelUpliftValidator;